"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doAfter = void 0;
var lodash_throttle_1 = __importDefault(require("lodash.throttle"));
function doAfter(callback, opts) {
    var middlewareCallback;
    if ((opts === null || opts === void 0 ? void 0 : opts.throttleBy) && opts.throttle) {
        middlewareCallback = (0, lodash_throttle_1.default)(callback, opts.throttleBy, { trailing: true });
    }
    else {
        middlewareCallback = callback;
    }
    return function (_a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        return function (next) {
            return function (action) {
                var result = next(action);
                middlewareCallback(dispatch, getState);
                return result;
            };
        };
    };
}
exports.doAfter = doAfter;
//# sourceMappingURL=utils.js.map